// Product Page Accordion
document.addEventListener("DOMContentLoaded", function () {
  var acc = document.getElementsByClassName("beseen_accordion");

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      var panel = this.nextElementSibling;

      // Fix: Prevent errors if nextElementSibling is missing
      if (!panel || !panel.classList.contains("beseen_panel")) return;

      var plusIcon = this.querySelector(".plus-icon");
      var minusIcon = this.querySelector(".minus-icon");

      if (!plusIcon || !minusIcon) return;

      // Close all other accordions before opening the clicked one
      for (var j = 0; j < acc.length; j++) {
        if (acc[j] !== this) {
          acc[j].classList.remove("beseen_active");
          var otherPanel = acc[j].nextElementSibling;
          if (otherPanel && otherPanel.classList.contains("beseen_panel")) {
            otherPanel.style.maxHeight = null;
          }
        }
      }

      // Toggle active class and maxHeight for the clicked accordion
      this.classList.toggle("beseen_active");

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
});
// Shop the Look JS

document.addEventListener("DOMContentLoaded", function () {
  $(".ifp-inner").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow:
      '<button class="slick-next next-arrow icon icon--next"><span class="visuallyhidden">Next slides</span></button>',
    prevArrow:
      '<button class="slick-prev prev-arrow icon icon--prev"><span class="visuallyhidden">Previous slides</span></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".stl-right--slider").slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: function (slider, i) {
      return "<span></span>";
    },
  });
  var $scale, $transform, i, e, n, s, a, o, r, l;
  $(".stl-dot").click(function () {
    var $index = $(this).data("index");
    $(".stl-right--slider").slick("slickGoTo", $index);
    $(".stl-dot").removeClass("stl-dot--active");
    $(this).addClass("stl-dot--active");
    // if($(window).width() <= 991){
    //   if(!$('.stl-wrapper').hasClass('zoomed-in')){
    //     $scale = 1+($('.stl-left').width()/$(window).width());
    //     $('html,body').addClass('no-scroll');
    //     $('.stl-wrapper').addClass('zoomed-in');

    //     i = document.querySelector('.stl-left');
    //     e = document.querySelector('.stl-right--inner')
    //     n = window.innerWidth / (i.offsetWidth - 2 * parseInt(window.getComputedStyle(i).paddingLeft));
    //     s = Math.round(i.offsetHeight * n),
    //       a = Math.round(Math.max(s - (window.innerHeight - e.offsetHeight), 0)),
    //       o = s - a,
    //       r = Math.round(-(i.getBoundingClientRect().top - (s - i.offsetHeight) / 2)),
    //       l = Math.round(r - a);
    //   }
    //   e = document.querySelector('.stl-dot.stl-dot--active')
    //   i = Math.round((e.offsetTop + e.offsetHeight / 2) * n),
    //     s = Math.round(i - o / 2),
    //     a = Math.min(Math.max(r - s, l), r);

    //   $('.stl-left').css('transform','translateY('+a+'px) scale('+n+')');
    // }
  });
  $(".stl-right-header span").click(function () {
    $("html,body").removeClass("no-scroll");
    $(".stl-wrapper").removeClass("zoomed-in");

    $(".stl-left").css("transform", "scale(1)");
  });
  $(".stl-right--slider").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var $index = currentSlide;
      if (
        !$('.stl-dot[data-index="' + $index + '"]').hasClass("stl-dot--active")
      ) {
        $(".stl-dot").removeClass("stl-dot--active");
        $('.stl-dot[data-index="' + $index + '"]')
          .addClass("stl-dot--active")
          .trigger("click");
      }
    }
  );
});

const products_on_page = document.getElementById("product-grid");
let next_url = products_on_page.dataset.nextUrl;

const load_more_btn = document.getElementsByClassName("load-more_btn")[0];
const load_more_spinner =
  document.getElementsByClassName("load-more_spinner")[0];
async function getNextPage() {
  try {
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

// Collection page load more button script
// async function loadMoreProducts() {
//   load_more_btn.style.display = 'none';
//   load_more_spinner.style.display = 'block';
//   let nextPage = await getNextPage();

//   const parser = new DOMParser();
//   const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

//   load_more_spinner.style.display = 'none';

//   const productgrid = nextPageDoc.getElementById('product-grid');
//   const new_products = productgrid.getElementsByClassName('grid__item');
//   const new_url = productgrid.dataset.nextUrl;
//   if (new_url) {
//     load_more_btn.style.display = 'block';
//   }
//   next_url = new_url;
//   for (let i = 0; i < new_products.length; i++) {
//     products_on_page.appendChild(new_products[i]);
//   }
// }

// document.addEventListener("DOMContentLoaded", function () {
//   const loadMoreBtn = document.getElementById("load-more-btn");
//   const loadMoreSpinner = document.getElementById("load-more-spinner");
//   const productGrid = document.getElementById("product-grid");
//   let nextPageUrl = document.getElementById("next-page-url")
//     ? document.getElementById("next-page-url").dataset.url
//     : null;

//   function updateLoadMoreButton() {
//     if (nextPageUrl) {
//       loadMoreBtn.style.display = "block";
//     } else {
//       loadMoreBtn.style.display = "none";
//     }
//   }

//   async function fetchNextPage(url) {
//     try {
//       const response = await fetch(url);
//       if (!response.ok) throw new Error("Network response was not ok");
//       const text = await response.text();
//       return text;
//     } catch (error) {
//       console.error("Failed to fetch next page:", error);
//       return "";
//     }
//   }

//   async function loadMoreProducts() {
//     if (!nextPageUrl) return;

//     loadMoreBtn.style.display = "none";
//     loadMoreSpinner.style.display = "block";

//     const nextPageHtml = await fetchNextPage(nextPageUrl);
//     const parser = new DOMParser();
//     const nextPageDoc = parser.parseFromString(nextPageHtml, "text/html");

//     loadMoreSpinner.style.display = "none";

//     const newProducts = nextPageDoc.querySelectorAll(
//       "#product-grid .grid__item"
//     );
//     newProducts.forEach((product) => {
//       productGrid.appendChild(product);
//     });

//     const nextPageElement = nextPageDoc.querySelector("#next-page-url");
//     nextPageUrl = nextPageElement ? nextPageElement.dataset.url : null;

//     updateLoadMoreButton();
//   }

//   updateLoadMoreButton();

//   loadMoreBtn.addEventListener("click", loadMoreProducts);
// });
